//Document Types

export const GET_VEHICALLIST_REQUEST = 'GET_VEHICALLIST_REQUEST';
export const GET_VEHICALLIST_SUCCESS = 'GET_VEHICALLIST_SUCCESS';
export const GET_VEHICALLIST_FAIL = 'GET_VEHICALLIST_FAIL';

export const GET_VEHICALHISTORY_REQUEST = 'GET_VEHICALHISTORY_REQUEST';
export const GET_VEHICALHISTORY_SUCCESS = 'GET_VEHICALHISTORY_SUCCESS';
export const GET_VEHICALHISTORY_FAIL = 'GET_VEHICALHISTORY_FAIL';

export const GET_DOCUMENTLIST_REQUEST = "GET_DOCUMENTLIST_REQUEST";
export const GET_DOCUMENTLIST_SUCCESS = "GET_DOCUMENTLIST_SUCCESS";
export const GET_DOCUMENTLIST_FAIL = "GET_DOCUMENTLIST_FAIL";

export const CREATE_DOCUMENT_REQUEST = "CREATE_DOCUMENT_REQUEST"
export const CREATE_DOCUMENT_SUCCESS = "CREATE_DOCUMENT_SUCCESS"
export const CREATE_DOCUMENT_FAIL = "CREATE_DOCUMENT_FAIL"

export const UPLOAD_DOCUMENT_REQUEST = "UPLOAD_DOCUMENT_REQUEST"
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS"
export const UPLOAD_DOCUMENT_FAIL = "UPLOAD_DOCUMENT_FAIL"

export const CHECK_VEHICLE_REQUEST = "CHECK_VEHICLE_REQUEST"
export const CHECK_VEHICLE_SUCCESS = "CHECK_VEHICLE_SUCCESS"
export const CHECK_VEHICLE_FAIL = "CHECK_VEHICLE_FAIL"